import { Link } from "react-router-dom";
import "../styles/HomeNew.css";
import { PayPalButtons } from "@paypal/react-paypal-js";
import React, { useState } from "react";

export default function NotFoundPage() {
  const [amount] = useState("19.99");
  return (
    <div className="pg">
      <section className="hero" style={{ minHeight: "80svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr", textAlign: "center" }}>
          <div className="hero__text" style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <p className="hero__kicker">Error 404</p>
            <h1 className="hero__h1" style={{ fontSize: "clamp(4rem, 12vw, 10rem)", lineHeight: 1 }}>
              <span className="hero__accent">Oops!</span>
            </h1>
            <p className="hero__sub" style={{ textAlign: "center" }}>
              We couldn't find the page you're looking for. Please check the URL or navigate back to a page that exists.
            </p>
            <div className="hero__ctas" style={{ justifyContent: "center" }}>
              <Link to="/" className="cta cta--solid">← Back to Home</Link>
              <Link to="/projects" className="cta cta--ghost">View Projects</Link>
            </div>
          </div>
        </div>
      </section>
      <div style={{ maxWidth: 400, margin: "40px auto" }}>
        <h2>Checkout</h2>
        <p>Total: ${amount}</p>

        <PayPalButtons
          style={{ layout: "vertical" }}
          createOrder={async () => {
            const res = await fetch("http://localhost:5000/api/orders", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ amount }),
            });
            const data = await res.json();
            return data.id; // PayPal order ID
          }}
          onApprove={async (data, actions) => {
            const res = await fetch(
              `http://localhost:5000/api/orders/${data.orderID}/capture`,
              {
                method: "POST",
              }
            );
            const captureData = await res.json();
            console.log("Capture result:", captureData);
            alert("Payment successful!");
          }}
          onError={(err) => {
            console.error(err);
            alert("Payment error");
          }}
        />
      </div>
    </div>
  );
}